/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_CURRENT_DISPUTE_DISPLAY_OBJ_ACT =
  'GET_CURRENT_DISPUTE_DISPLAY_OBJ';
export const GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ_ACT =
  'GET_CURRENT_DISPUTE_DISPLAY_DETAIL_OBJ';
export const GET_PLAN_TYPE_DATA_ACT = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_ACT = 'GET_REBATE_PROGRAM';
export const GET_REBATE_PROGRAM_NAME_ACT = 'GET_REBATE_PROGRAM_NAME_ACT';
export const GET_ERROR_MSG_DISPUTE_ACTIVITY = 'GET_ERROR_MSG_DISPUTE_ACTIVITY';
export const LEFT_SIDE_TABLEDETAILS = 'LEFT_SIDE_TABLEDETAILS';
export const RIGHT_SIDE_TABLEDETAILS = 'RIGHT_SIDE_TABLEDETAILS';
export const DUPLICATE_ERRORS = 'DUPLICATE_ERRORS';
export const SEARCH_MFG_DISP_ACTIVITY = 'SEARCH_MFG_DISP_ACTIVITY';
export const NDC_LOADING = 'NDC_LOADING';
export const MANUFACTURER_GRID_ACT = 'MANUFACTURER_GRID_ACT';
export const GRID_MFG_ACT = 'GRID_MFG_ACT';
export const GRID_NDC_ACT = 'GRID_NDC_ACT';
export const SELECT_OPTION = 'SELECT_OPTION';
export const SELECTED_DISPUTE_CODE = 'SELECTED_DISPUTE_CODE';
export const GET_ALL_LABELER_ACT = 'GET_ALL_LABELER_ACT';
export const DISPLAY_DISPUTE_CODE = 'DISPLAY_DISPUTE_CODE';
export const GET_MANUFACTURER_NAME_ACT = 'GET_MANUFACTURER_NAME_ACT';
export const GET_MANUFACTURER_ID_ACT = 'GET_MANUFACTURER_ID_ACT';
export const GET_DRUG_DATA_ACT = 'GET_DRUG_DATA_ACT';
export const SET_STATUS_ACT = 'SET_STATUS_ACT';
export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
export const REFRESH_DISPUTE_ACTIVITY = 'REFRESH_DISPUTE_ACTIVITY';
export const REFRESH_DISPUTE_ACTIVITY_DISPLAY =
  'REFRESH_DISPUTE_ACTIVITY_DISPLAY';

export const SET_MFG_COUNT = 'SET_MFG_COUNT';
export const SET_DISPLAY_OBJ_ACTIVITY = 'SET_DISPLAY_OBJ_ACTIVITY';
export const SET_EXPORT_ALL_DISPUTE_ACTIVITY =
  'SET_EXPORT_ALL_DISPUTE_ACTIVITY';
export const SET_PAGINATION_INDEX_DISPUTE_ACTIVITY =
  'SET_PAGINATION_INDEX_DISPUTE_ACTIVITY';
